import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { FilterTree, SegmentEntityType } from "@colab/shared";

export type SegmentRow = {
  id: string;
  entity_type: SegmentEntityType;
  name: string;
  description: string | null;
  filter: FilterTree;
  created_by: string | null;
  created_at: string;
  updated_at: string;
};

// GET /api/settings/segments — saved boolean-filter listings.
export function useSegments() {
  return useQuery<SegmentRow[], ApiClientError>({
    queryKey: queryKeys.settings.segments(),
    queryFn: () => apiFetch<SegmentRow[]>("/settings/segments"),
  });
}
